import Validator from '../Validator';
import ValidatorInterface from '../ValidatorInterface';

export default class ValidatorString extends Validator implements ValidatorInterface {

    /**
     * Check if value is valid
     *
     * @param value
     * @param index
     * @param offset
     */

    public check(value: string, index: number, offset: number): boolean {

        if (!this.isString(value)) {
            this.addError("Non string value", index, value);
            return false;
        }

        if (value.length > 150) {
            this.addError("Maximum length for string is 150 characters", index, value);
            return false;
        }

        return true;
    }
}